<template>
  <div class="main">
    <b-tabs>
      <b-tab title="My Leaves" active>
        <b-row>
          <b-col
            col="12"
            sm="4"
            v-for="(item, index) in leaveBalance"
            :id="index"
            :key="index"
          >
            <b-card class="earnings-card">
              <b-card-body
                class="d-flex justify-content-between align-items-center"
              >
                <div class="truncate">
                  <h4 class="mb-25 font-weight-bolder">
                    {{ item.title }}
                  </h4>
                </div>
                <div>
                  <h3 class="mb-25 font-weight-bolder">
                    {{ item.balance }}
                  </h3>
                </div>
                <!-- <b-avatar variant="light-info" size="45">
                  <feather-icon size="21" icon="UmbrellaIcon" />
                </b-avatar> -->
              </b-card-body>
            </b-card>
          </b-col>
          <!--  -->
        </b-row>

        <b-row>
          <b-table
            responsive="sm"
            :fields="fields"
            :items="employeeLeaves"
            v-show="false"
          >
          </b-table>
        </b-row>
      </b-tab>
      <b-tab title="My Subordinate Leaves">
        <b-card>
          <b-card-body>
            <b-row>
              <b-col md="2" sm="4" class="my-1">
                <b-form-group class="mb-0">
                  <label class="d-inline-block text-sm-left mr-50"
                    >Per page</label
                  >
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                    class="w-50"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4" sm="8" class="my-1">
                <b-form-group
                  label="Sort"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-select
                      id="sortBySelect"
                      v-model="sortBy"
                      :options="sortOptions"
                      class="w-75"
                    >
                      <template v-slot:first>
                        <option value="">-- none --</option>
                      </template>
                    </b-form-select>
                    <b-form-select
                      v-model="sortDesc"
                      size="sm"
                      :disabled="!sortBy"
                      class="w-25"
                    >
                      <option :value="false">Asc</option>
                      <option :value="true">Desc</option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6" class="my-1">
                <b-form-group
                  label="Filter"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      id="filterInput"
                      v-model="filter"
                      type="search"
                      placeholder="Type to Search"
                    />
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">
                        Clear
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-table
                  striped
                  hover
                  responsive
                  :per-page="perPage"
                  :current-page="currentPage"
                  :items="displayedItems"
                  :fields="employee_leave_balance_fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template #cell(employeeID)="data">
                    {{ getSubsName(data.item) }}
                  </template>

                  <template v-slot:cell(actions)="data">
                    <b-button
                      variant="primary"
                      @click="ViewSubordinate(data.item)"
                    >
                      <feather-icon icon="EyeIcon" />
                      <span class="align-middle ml-50">View</span>
                    </b-button>
                  </template>
                </b-table>
              </b-col>

              <b-modal
                ref="modalSubsdetails"
                id="modal-view-subd"
                title="View Subordinate Leaves"
                size="lg"
                hide-footer
                centered
              >
                <b-row>
                  <b-col md="12">
                    <h3 class="mb-25 font-weight-bolder">
                      {{ getSubsName(viewSubs.employeeID) }}
                    </h3>
                  </b-col>
                </b-row>

                <b-row>
                  <div>
                    <b-row>
                      <b-col
                        md="4"
                        v-for="(item, index) in getSubsLeaves(
                          viewSubs.employeeID
                        )"
                        :id="index"
                        :key="index"
                      >
                        <b-card class="earnings-card">
                          <b-card-body
                            class="d-flex justify-content-between align-items-center"
                          >
                            <div class="truncate">
                              <h4 class="mb-25 font-weight-bolder">
                                {{ item.title }}
                              </h4>
                            </div>
                            <div>
                              <h3 class="mb-25 font-weight-bolder">
                                {{ item.balance }}
                              </h3>
                            </div>
                            <!-- <b-avatar variant="light-info" size="45">
                  <feather-icon size="21" icon="UmbrellaIcon" />
                </b-avatar> -->
                          </b-card-body>
                        </b-card>
                      </b-col>
                      <!--  -->
                    </b-row>
                  </div>

                  <b-row>
                    <b-table
                      responsive="sm"
                      :fields="fields"
                      :items="employee_leave_balance_items"
                      v-show="false"
                    >
                    </b-table>
                  </b-row>
                </b-row>
              </b-modal>

              <b-col cols="12">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="center"
                  size="sm"
                  class="my-0"
                />
              </b-col>
              <b-form-group>
                Showing
                {{ totalRows > 0 ? perPage * (currentPage - 1) + 1 : 0 }}
                to
                {{
                  totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0
                }}
                of
                {{ totalRows > 0 ? totalRows : 0 }}
                entries
              </b-form-group>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BCardBody,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BCardText,
  BCardTitle,
  BCardSubTitle,
  BDropdown,
  BLink,
  BDropdownItem,
  BTab,
  BTabs,
} from "bootstrap-vue";
import { data } from "jquery";
import { mapGetters, mapActions } from "vuex";
import { IsAdmin } from "@/@core/utils/validations/permissionCheck";
// import ViewEmployeeLeaveBalance from "./ViewEmployeeLeaveBalance.vue";

export default {
  components: {
    BCard,
    BTable,
    BCardBody,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BDropdownItem,
    BTab,
    BTabs,
    BCardText,
    BCardTitle,
    BCardSubTitle,
    // ViewEmployeeLeaveBalance,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      leaveBalance: null,
      subleaveBalance: null,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 0,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",

      filterOn: [],
      //leaveTypes: [],
      fields: [
        { key: "leaveType", label: "Leave Type", sortable: true },
        { key: "remainingBalance", label: "Remaining Balance", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      subordinatesfields: [
        { key: "employeeID", label: "Employee Name", sortable: true },
        // ...this.leaveTypes.map(leaveType => ({
        //     key: leaveType,
        //     label: leaveType,
        //     sortable: true,
        //   })),
      ],
      employee_leave_balance_fields: [
        { key: "employeeID", label: "Employee Name", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      viewSubs: {
        employeeID: null,
        leaveType: null,
        initialBalance: null,
        leaveTaken: null,
        remainingBalance: null,
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("leavebalanceModule", {
      employee_leave_balance_items: "subordinate",
      employeeLeaves: "employee",
      loading: "loading",
    }),

    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),

    ...mapGetters("leavetypeModule", {
      leavetypes: "leavetypes",
      loading: "loading",
    }),
  },

  methods: {
    ...mapActions("employeeModule", ["getEmployeeListAction"]),
    ...mapActions("leavebalanceModule", [
      "getLeaveBalanceEmployeeAction",
      "getLeaveBalanceSubordinatesAction",
    ]),

    ...mapActions("leavetypeModule", ["getLeaveTypeListAction"]),
    getDistinctSubordinates() {
      //console.log([...new Set(this.employee_leave_balance_items.map(item => item.employeeID))], 'emp');
      let balance = [
        ...new Set(
          this.employee_leave_balance_items.map((item) => item.employeeID)
        ),
      ];
      console.log("balance", balance);
      return balance;
    },

    updateDisplayedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;

      if (!IsAdmin()) {
        console.log("not admin");
        this.displayedItems = this.getDistinctSubordinates();
        this.totalRows = this.displayedItems.length;
      } else {
        console.log("admin user");
        console.log("subordinates", this.employee_leave_balance_items);
        this.displayedItems = this.getDistinctSubordinates();
        this.totalRows = this.displayedItems.length;
      }
    },

    getLeaveType(id) {
      const leave = this.leavetypes.find((s) => s.leaveTypeId === id);
      return leave ? leave.title : "-";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getSubsName(id) {
      const employee = this.employeeList.find((s) => s.id === id);
      console.log("employesssssssssssssss", this.employeeList);
      console.log("idddddddddddddddddddddddddddd", id);
      return employee ? employee.firstName + " " + employee.lastName : "-";
    },

    getSubTakenLeaves(id, leaveTypeID) {
      //       console.log(leaveTypeID);

      //         console.log(this.employee_leave_balance_items
      //         .filter(
      //           (subleave) =>
      //             subleave.employeeID == id
      //         ), 'leavesall');

      // console.log(this.employee_leave_balance_items
      //         .filter(
      //           (subleave) =>
      //             subleave.employeeID == id && subleave.leaveTypeID == leaveTypeID
      //         ), 'leaves');

      return this.employee_leave_balance_items
        .filter(
          (subleave) =>
            subleave.employeeID == id && subleave.leaveTypeID == leaveTypeID
        )
        .reduce((sum, subleave) => sum + subleave.leaveTaken, 0);
    },

    getSubsLeaves(id) {
      //console.log(this.leavetypes,'leavetypes');

      return this.leavetypes
        .filter((item) => item.status !== "DEACTIVATE")
        .map((subleave) => ({
          title: subleave.title,
          balance:
            subleave.balance - this.getSubTakenLeaves(id, subleave.leaveTypeId),
        }));
    },

    ViewSubordinate(item) {
      this.viewSubs = {
        employeeID: item,
        leaveType: null,
        initialBalance: null,
        leaveTaken: null,
        remainingBalance: null,
      };
      this.$refs.modalSubsdetails.show();
    },
  },

  async mounted() {
    await this.getLeaveBalanceEmployeeAction();
    await this.getEmployeeListAction();

    if (!IsAdmin()) {
      await this.getLeaveBalanceSubordinatesAction().then(() => {
        this.totalRows = this.getDistinctSubordinates().length;
      });
    } else {
      await this.getLeaveBalanceSubordinatesAction().then(() => {
        this.totalRows = this.employee_leave_balance_items.length;
      });
    }

    await this.getLeaveTypeListAction();

    this.updateDisplayedItems();

    this.leaveBalance = this.leavetypes
      .filter((item) => item.status !== "DEACTIVATE")
      .map((item) => {
        // console.log(item, "item");
        // console.log(this.employeeLeaves, "this.employeeLeaves");

        const totalLeaveTaken = this.employeeLeaves
          .filter((leave) => leave.leaveTypeID == item.leaveTypeId)
          .reduce((sum, leave) => sum + leave.leaveTaken, 0);

        return {
          title: item.title,
          balance: item.balance - totalLeaveTaken,
        };
      });
  },
  setup() {
    return {
      IsAdmin,
    };
  },
  watch: {
    currentPage(newPage) {
      // Update the list based on the new page, perPage, and filter
      this.updateDisplayedItems();
    },
  },
};
</script>
